import { AppSubjectEnum } from '../../authz/enums/app-subject.enum';
import { CaslSubject } from '../../authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../base/dtos/base.dto';

/**
 * Vehicle model DTO for records
 */
@CaslSubject(AppSubjectEnum.VEHICLE)
export class VehicleModelRecordDto extends BaseDto {
	uuid!: string;
	name!: string;
	notes?: string;
	externalReference?: string;
	makeId!: number;

	mobileTitle = (): string | null => {
		return `${this.name}`;
	};

	mobileSubtitle = (): string | null => {
		return '';
	};
}
